import { useReveal } from "@/lib/useReveal";
import { SunBurst } from "@/components/illustrations/Illustrations";

const PAINS = [
    {
        title: "Вы теряете контроль над сроками",
        text: "Сроки горят, разработчики работают ночами, а результат всё равно сдвигается вправо.",
    },
    {
        title: "Хаос вместо процессов",
        text: "Задачи теряются, приоритеты меняются на лету, а команда тратит время на выяснение «кто кому что должен», а не на работу.",
    },
    {
        title: "Разработка не даёт результата",
        text: "Релизы выходят, а бизнес-показатели стоят на месте. Вы вкладываете деньги в ИТ, но не видите отдачи.",
    },
    {
        title: "CTO ушёл — и забрал контекст",
        text: "Вся архитектура и логика — в голове одного человека. Если он уйдёт, вы останетесь без понимания, как работает ваш продукт.",
    },
    {
        title: "Вы зависите от ИТ, а не управляете им",
        text: "Отчёты есть, но вы не можете принять на их основе решение. Вы чувствуете, что не контролируете ситуацию.",
    },
    {
        title: "Хотите свою команду разработки",
        text: "Решение принято, идея есть — но как выстроить процессы разработки ПО с нуля, непонятно.",
    },
];

export const PainPoints = () => {
    const ref = useReveal();
    return (
        <section
            id="for-you"
            data-testid="pains-section"
            className="relative py-28 sm:py-40 border-t border-[#1B2A41]/15"
        >
            <div ref={ref} className="vnutri-reveal max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 mb-20">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="w-12 h-px bg-[#C46342]" />
                            <span className="text-[11px] tracking-[0.4em] uppercase font-semibold text-[#C46342]">
                                01 · Контекст
                            </span>
                        </div>
                        <h2
                            data-testid="pains-title"
                            className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-[-0.03em] text-[#1B2A41] font-extralight leading-[1.02]"
                        >
                            Я полезна,{" "}
                            <span className="font-semibold">если вы…</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 relative lg:pt-6">
                        <p className="text-lg sm:text-xl leading-[1.6] text-[#1B2A41]/80 font-light max-w-xl">
                            Если это о вас и вы хотите изменить ситуацию без замены команды, — мы найдём формат, который вернёт ИТ‑разработке понятность и управляемость.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#1B2A41]/15">
                    {PAINS.map((p, i) => (
                        <article
                            key={i}
                            data-testid={`pain-card-${i}`}
                            className="group relative p-10 lg:p-12 border-r border-b border-[#1B2A41]/15 bg-white hover:bg-[#F4F1EA] transition-colors"
                        >
                            <div className="flex items-start gap-5">
                                <span className="mt-2 inline-block w-3 h-3 bg-[#C46342] shrink-0 group-hover:rotate-45 transition-transform duration-500" />
                                <div>
                                    <h3 className="text-xl sm:text-2xl font-semibold tracking-[-0.01em] text-[#1B2A41] leading-tight">
                                        {p.title}
                                    </h3>
                                    <p className="mt-4 text-sm sm:text-base leading-[1.7] text-[#1B2A41]/75 font-light">
                                        {p.text}
                                    </p>
                                </div>
                            </div>
                            <span className="absolute top-5 right-6 text-[11px] tracking-[0.28em] text-[#1B2A41]/30 font-mono">
                                0{i + 1}
                            </span>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
